
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutcmOlMtgh0xy7aWxAyOhlQufva4uyAY4tLm1ILX3BBaUMeta } from "/opt/build/repo/pages/about.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as contactUtUBN6u09MOBXpCX2V4MTnIvODrHK3on_Sjbujn1zJsMeta } from "/opt/build/repo/pages/contact.vue?macro=true";
import { default as indexaeNnnSaL45Ld6iIiy8gNY7lyYKzxZMXv_45iuIPbJKm6sMeta } from "/opt/build/repo/pages/project/index.vue?macro=true";
import { default as _91slug_93kJdtlj_Xtm6jCOaT_45r_NzomnJDTqnRtzHTje9D5Z0vgMeta } from "/opt/build/repo/pages/project/[slug].vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/about",
    component: () => import("/opt/build/repo/pages/about.vue")
  },
  {
    name: "about___fr",
    path: "/fr/about",
    component: () => import("/opt/build/repo/pages/about.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "project___en",
    path: "/project",
    component: () => import("/opt/build/repo/pages/project/index.vue")
  },
  {
    name: "project___fr",
    path: "/fr/project",
    component: () => import("/opt/build/repo/pages/project/index.vue")
  },
  {
    name: "project-slug___en",
    path: "/project/:slug()",
    component: () => import("/opt/build/repo/pages/project/[slug].vue")
  },
  {
    name: "project-slug___fr",
    path: "/fr/project/:slug()",
    component: () => import("/opt/build/repo/pages/project/[slug].vue")
  }
]